import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { loginFormConfiguration } from '../../../utils/form-configs/login.form';
import { getFormErrorMessage } from '../../../utils/form-error-parser';
import { signIn } from '../../../redux/thunks/auth';
import { ComponentContainer, FormContainer } from './login.styles';

const LoginPage = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    clearErrors,
  } = useForm({});

  const { isAuthenticating } = useSelector((state) => state.entities.user);

  useEffect(() => {
    watch(() => clearErrors('invalid'));
  }, [watch, clearErrors]);

  const onSubmit = (formData) => {
    const onSuccess = (message) => enqueueSnackbar(message, { variant: 'success' });
    const onFailure = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(signIn({ formData, onSuccess, onFailure }));
  };

  return (
    <ComponentContainer>
      <FormContainer>
        <h2 style={{ textAlign: 'center' }}>Login</h2>
        {Object.entries(loginFormConfiguration).map(
          ([key, { label, placeholder, type, validation }]) => {
            return (
              <Form.Group key={key}>
                <Form.Label>{label}</Form.Label>
                <Form.Control
                  type={type}
                  placeholder={placeholder}
                  name={key}
                  {...register(key, {
                    ...(validation || {}),
                  })}
                  disabled={isAuthenticating}
                />
                {errors[key] && (
                  <Form.Text className="text-danger">
                    {getFormErrorMessage(errors[key], validation)}
                  </Form.Text>
                )}
              </Form.Group>
            );
          }
        )}
        <Button
          variant="primary"
          style={{
            width: '100%',
          }}
          onClick={handleSubmit(onSubmit)}
          disabled={isAuthenticating}
        >
          Login
        </Button>
        {isAuthenticating && (
          <Form.Text
            style={{
              textAlign: 'center',
            }}
          >
            <Spinner animation="border" variant="primary" />
          </Form.Text>
        )}
      </FormContainer>
    </ComponentContainer>
  );
};

export default LoginPage;
